import s from './TimeEstimationScatterChart.module.scss';

type CategoryPieTooltipProps = {
  active?: boolean;
  payload?: Array<{ payload?: { name?: string } }>;
};

export function CategoryPieTooltip({ active, payload }: CategoryPieTooltipProps) {
  if (!active || !payload?.length) {
    return null;
  }

  const name = payload[0].payload?.name;

  if (!name) {
    return null;
  }

  return (
    <div className={s.pieTooltip} data-testid="estimation-pie-tooltip">
      {name}
    </div>
  );
}
